// Authorisation Enums ---------------------------------------------------------------------------------------------------------------------

export enum AuthorisationFields {
  Active = 'active',
  Authorisation = 'authorisation',
  Branch = 'branch',
  BranchId = 'branch_id',
  BranchName = 'branch_name',
  Company = 'company',
  CompanyId = 'company_id',
  CompanyName = 'company_name',
  CreatedAt = 'created_at',
  Email = 'email',
  ExternalRef = 'external_ref',
  Id = 'id',
  Level = 'level',
  Name = 'name',
  Product = 'product',
  ProductId = 'product_id',
  ProductName = 'product_name',
  ProductProfile = 'product_profile',
  ProductTitle = 'product_title',
  Role = 'role',
  Roles = 'roles',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updated_at',
}

export enum AuthorisationRole {
  ADMIN = 'ADMIN',
  VIEWER = 'VIEWER',
}

export enum AuthorisationProduct {
  CLOUD_ADMIN = 'CLOUD_ADMIN',
  PARTS_PORTAL = 'PARTS_PORTAL',
  PORTAL_ADMIN = 'PORTAL_ADMIN',
  PORTAL_TEMPLATE = 'PORTAL_TEMPLATE',
  SERVICE_PORTAL = 'SERVICE_PORTAL',
}

// Authorisation Constants -----------------------------------------------------------------------------------------------------------------

export const CORE_PRODUCT: AuthorisationProduct = AuthorisationProduct.PORTAL_ADMIN;

export const AuthorisationProductDetails: Record<AuthorisationProduct, AuthorisationProductDescription> = {
  [AuthorisationProduct.CLOUD_ADMIN]: {
    [AuthorisationFields.Name]: AuthorisationProduct.CLOUD_ADMIN,
    [AuthorisationFields.Title]: 'Cloud Admin',
  },
  [AuthorisationProduct.PARTS_PORTAL]: {
    [AuthorisationFields.Name]: AuthorisationProduct.PARTS_PORTAL,
    [AuthorisationFields.Title]: 'Parts Portal',
  },
  [AuthorisationProduct.PORTAL_ADMIN]: {
    [AuthorisationFields.Name]: AuthorisationProduct.PORTAL_ADMIN,
    [AuthorisationFields.Title]: 'Portal Admin',
  },
  [AuthorisationProduct.PORTAL_TEMPLATE]: {
    [AuthorisationFields.Name]: AuthorisationProduct.PORTAL_TEMPLATE,
    [AuthorisationFields.Title]: 'Portal Template',
  },
  [AuthorisationProduct.SERVICE_PORTAL]: {
    [AuthorisationFields.Name]: AuthorisationProduct.SERVICE_PORTAL,
    [AuthorisationFields.Title]: 'Service Portal',
  },
};

// Authorisation Interfaces ----------------------------------------------------------------------------------------------------------------

export interface AuthorisationCrud {
  [AuthorisationFields.Active]: boolean;
  [AuthorisationFields.Email]: string;
  [AuthorisationFields.Id]: number | null;
  [AuthorisationFields.Role]: AuthorisationRole;
}

export interface AuthorisationDetail {
  [AuthorisationFields.Active]: boolean;
  [AuthorisationFields.CreatedAt]: string | null;
  [AuthorisationFields.Email]: string;
  [AuthorisationFields.Id]: number;
  [AuthorisationFields.Role]: AuthorisationRole;
  [AuthorisationFields.UpdatedAt]: string | null;
}

export interface Authorisation {
  [AuthorisationFields.Active]: boolean;
  [AuthorisationFields.CreatedAt]: string | null;
  [AuthorisationFields.Id]: number;
  [AuthorisationFields.Email]: string;
  [AuthorisationFields.Role]: AuthorisationRole;
  [AuthorisationFields.UpdatedAt]: string | null;
}

export interface AuthorisationProductDescription {
  [AuthorisationFields.Name]: AuthorisationProduct;
  [AuthorisationFields.Title]: string;
}

export interface AuthorisationRedux {
  [AuthorisationFields.Authorisation]: Authorisation | null;
}
